module.exports = __webpack_public_path__ + "img/second-sale-send.cc3e3868.svg";